<div class="row">
    <div class="col-sm-12 col-xs-12 col-lg-6">
        <form [formGroup]="formTipo" #formDirective="ngForm">
            <div>
                <h1> Tipo de Ingreso</h1>
            </div>
            <div formArrayName="ArrForms" *ngFor=" let formArray of formArray?.controls; let i = index">
                <ng-container [formGroupName]="i">
                    <mat-checkbox formControlName="tipoOcupacionCheck"
                        (change)="checkboxChange($event, formArray.controls)"
                        style="padding-left: 10px; padding-rigth:10px;" class="example-margin">
                    </mat-checkbox>
                    <label style="padding-left: 1%;">{{formArray.controls.tipoOcupacionLabel.value}}</label>
                </ng-container>

            </div>
        </form>

    </div>

    <div class="col-sm-12 col-xs-12 col-lg-6">
        <form [formGroup]="observacionForm" #formDirective="ngForm">
            <mat-form-field style=" margin-top:30px ; position: relative;  width: 100%;   " class="observacion"
                appearance="outline">
                <mat-label>Observación</mat-label>
                <textarea style="resize: none; max-height:191px; min-height: 80%; height: 300px; " matInput
                    formControlName="observacion" type="text" placeholder="Observación"> </textarea>
            </mat-form-field>

            <mat-error *ngIf="observacionForm.controls.observacion.errors?.required">Campo requerido
            </mat-error>

        </form>
    </div>
</div>


<div class="row">
    <div class="col-lg-3 col-md-3 col-sm-4" style="
    padding-top: 1%;
">
        <button class="btn_l" mat-raised-button color="primary" matStepperPrevious>Volver</button>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-2"></div>
    <div class="col-lg-3 col-md-3 col-sm-2"></div>

    <div class="col-lg-3 col-md-3 col-sm-4" style="
    padding-top: 1%;
">
        <button class="btn_r" [disabled]="checkch?.length === 0 || observacionForm.controls.observacion.errors?.required" (click)="getFormulario()" mat-raised-button
            color="primary" matStepperNext>Continuar</button>
    </div>

</div>